import { getVerificationData } from 'api/v2/users/verifications';
import { useQuery, UseQueryOptions } from 'react-query';
import { UserCacheKeys } from 'types/cacheKeys.types';

const useVerifications = (
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'> & {
    partialKey?: string;
  },
) => {
  return useQuery(
    [UserCacheKeys.Verifications, options?.partialKey],
    () => getVerificationData(),
    options as any,
  );
};

export default useVerifications;
